import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Typography, Collapse, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
/**
 * ExpandableBlock – title + content (HTML) with optional "Show more" expand.
 */
const ExpandableBlock = ({ label, gradient, title, content = '', defaultExpanded = false, showMoreLabel = 'Show more', showLessLabel = 'Show less', paddingTop, paddingBottom, marginTop, marginBottom, maxWidth, fontFamily, fontWeight = 700, componentAlignment = 'left', }) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : 'transparent';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 3,
            paddingBottom: paddingBottom || 3,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 800, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 1, color: 'text.secondary', letterSpacing: 1 }, children: label })), _jsx(Typography, { variant: "h6", sx: {
                        mb: 2,
                        fontFamily: fontFamily || undefined,
                        fontWeight: Number(fontWeight) || 700,
                    }, children: title }), _jsx(Collapse, { in: expanded, collapsedSize: 0, children: _jsx(Box, { sx: {
                            fontFamily: fontFamily || undefined,
                            '& p': { mb: 1.5 },
                            '& ul, & ol': { pl: 3, mb: 1.5 },
                        }, dangerouslySetInnerHTML: { __html: content } }) }), _jsx(Button, { size: "small", onClick: () => setExpanded((e) => !e), endIcon: expanded ? _jsx(ExpandLessIcon, {}) : _jsx(ExpandMoreIcon, {}), sx: { mt: 1 }, children: expanded ? showLessLabel : showMoreLabel })] }) }));
};
export default ExpandableBlock;
